import { createAsyncThunk } from '@reduxjs/toolkit';
import { RetrieveMessageArg, retrieveMessages } from './messages-slice-helper';

export const checkForChanges = createAsyncThunk(
    'clubhouseMessages/checkForChanges',
    async (arg: RetrieveMessageArg, dispatch: any) =>
        await retrieveMessages(arg, dispatch)
);
